import { useMemo, useState } from "react";
import { TableUIColumn } from "./index";

interface Order {
  by: string;
  direction: "asc" | "desc";
}

const defaultSort = (prev: unknown, next: unknown) => {
  if (typeof prev === "number" && typeof next === "number") {
    return prev - next;
  }
  try {
    return JSON.stringify(prev).localeCompare(JSON.stringify(next));
  } catch {
    return 0;
  }
};

export const useSort = <Key extends string, Row extends Record<Key, unknown>>(
  columns?: TableUIColumn<Row>[],
  data?: Row[],
) => {
  const [order, setOrder] = useState<Order>();

  const result = useMemo(() => {
    if (data === undefined) {
      return undefined;
    }

    const indexed = data.map((row, index) => {
      return { row, index };
    });
    if (order === undefined) {
      return indexed;
    }

    const key = order.by as Key;
    const direction = order.direction === "desc" ? -1 : 1;

    const method =
      columns?.find((column) => column.key === key)?.sort ?? defaultSort;

    // TODO: typescript>=5.0: use toSorted ES2023 method
    const sorted = indexed.slice().sort((a, b) => {
      return method(a.row[key], b.row[key]) * direction;
    });

    return sorted;
  }, [columns, data, order]);

  return [result, order, setOrder] as const;
};
